import { Tool } from '@/shared/types/brain';

/** Metadata for rendering a local tool in the @ suggestion menu */
export type LocalToolDefinition = {
  tool: Tool;
  labelKey: string;
  descriptionKey: string;
  /** Whether this tool requires a sub-argument (e.g. workflow name) */
  requiresArgument: boolean;
};

/** Props for the localTool inline content spec */
export type LocalToolInlineProps = { toolName: string; argument: string; argumentLabel: string };

/** Static definitions of all local tools */
export const LOCAL_TOOL_DEFINITIONS: LocalToolDefinition[] = [
  {
    tool: Tool.TRIGGER_WORKFLOW,
    labelKey: 'local_tools.trigger_workflow',
    descriptionKey: 'local_tools.trigger_workflow_description',
    requiresArgument: true,
  },
  {
    tool: Tool.COMPOSE_RICH_RESPONSE,
    labelKey: 'local_tools.compose_rich_response',
    descriptionKey: 'local_tools.compose_rich_response_description',
    requiresArgument: false,
  },
  {
    tool: Tool.EXECUTE_CODE,
    labelKey: 'local_tools.execute_code',
    descriptionKey: 'local_tools.execute_code_description',
    requiresArgument: false,
  },
  {
    tool: Tool.VOICEMAIL_DETECTION,
    labelKey: 'local_tools.voicemail_detection',
    descriptionKey: 'local_tools.voicemail_detection_description',
    requiresArgument: false,
  },
  {
    tool: Tool.SEARCH_KNOWLEDGE_BASE,
    labelKey: 'local_tools.search_knowledge_base',
    descriptionKey: 'local_tools.search_knowledge_base_description',
    requiresArgument: false,
  },
  {
    tool: Tool.ASK_QUESTIONS,
    labelKey: 'local_tools.ask_questions',
    descriptionKey: 'local_tools.ask_questions_description',
    requiresArgument: false,
  },
];
